import { render } from "./EditLiquidationAttachments.vue?vue&type=template&id=e1f36754"
import script from "./EditLiquidationAttachments.vue?vue&type=script&lang=js"
export * from "./EditLiquidationAttachments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__